import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

export async function generatePdfFromTable(columnas, datos, titulo = "Listado", filename = "tabla.pdf", stripped = false) {
    const pdfDoc = await PDFDocument.create();
    let page = pdfDoc.addPage([595.28, 841.89]); // A4 vertical
    const { width, height } = page.getSize();

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 10;
    const margin = 40;
    const headerHeight = 40;
    const rowHeight = 20;

    const totalPx = columnas.reduce((sum, c) => sum + c.ancho, 0);
    const colWidths = columnas.map(c => (c.ancho / totalPx) * (width - 2 * margin));

    let y = height - margin;

    const drawHeader = (page) => {
        const fecha = new Date().toLocaleDateString();

        // Fondo del encabezado
        page.drawRectangle({
            x: 0,
            y: height - headerHeight,
            width,
            height: headerHeight,
            color: rgb(0.9, 0.9, 0.9),
        });

        // Texto del título
        page.drawText(titulo, {
            x: margin,
            y: height - 28,
            size: 14,
            font,
            color: rgb(0, 0, 0),
        });

        // Fecha a la derecha
        page.drawText(fecha, {
            x: width - margin - 100,
            y: height - 28,
            size: 10,
            font,
            color: rgb(0, 0, 0),
        });
    };

    // Dibujar encabezado inicial
    drawHeader(page);
    y -= headerHeight + 10;

    // --- Dibujar encabezado de tabla ---
    let x = margin;
    columnas.forEach((col, i) => {
        page.drawRectangle({
            x,
            y: y - rowHeight,
            width: colWidths[i],
            height: rowHeight,
            color: rgb(0.16, 0.5, 0.73),
        });
        page.drawText(col.titulo, {
            x: x + 2,
            y: y - rowHeight + 5,
            size: fontSize,
            font,
            color: rgb(1, 1, 1),
        });
        x += colWidths[i];
    });
    y -= rowHeight;

    // --- Dibujar filas de datos ---
    datos.forEach((row, rowIndex) => {
        x = margin;

        // Efecto zebra (si stripped es true)
        const bgColor = stripped && rowIndex % 2 === 1 ? rgb(0.95, 0.95, 0.95) : rgb(1, 1, 1);

        columnas.forEach((col, i) => {
            const isFirst = i === 0;
            const isLast = i === columnas.length - 1;

            // Dibujar fondo y bordes verticales (sin líneas horizontales)
            page.drawRectangle({
                x,
                y: y - rowHeight,
                width: colWidths[i],
                height: rowHeight,
                color: bgColor,
            });

            // Líneas verticales izquierda/derecha
            if (isFirst) {
                page.drawLine({
                    start: { x, y },
                    end: { x, y: y - rowHeight },
                    thickness: 1,
                    color: rgb(0, 0, 0),
                });
            }
            if (isLast) {
                page.drawLine({
                    start: { x: x + colWidths[i], y },
                    end: { x: x + colWidths[i], y: y - rowHeight },
                    thickness: 1,
                    color: rgb(0, 0, 0),
                });
            }

            // Texto de celda
            //const text = row[col.campo] != null ? String(row[col.campo]) : "";
            const text = row[i] != null ? String(row[i]) : "";
            page.drawText(text, {
                x: x + 2,
                y: y - rowHeight + 5,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
            });

            x += colWidths[i];
        });

        y -= rowHeight;

        // Si no cabe la fila, agregar nueva página
        if (y < margin + rowHeight) {
            page = pdfDoc.addPage([595.28, 841.89]);
            y = height - margin;
            drawHeader(page);

            // Volver a dibujar encabezado de tabla
            x = margin;
            columnas.forEach((col, i) => {
                page.drawRectangle({
                    x,
                    y: y - rowHeight,
                    width: colWidths[i],
                    height: rowHeight,
                    color: rgb(0.16, 0.5, 0.73),
                });
                page.drawText(col.titulo, {
                    x: x + 2,
                    y: y - rowHeight + 5,
                    size: fontSize,
                    font,
                    color: rgb(1, 1, 1),
                });
                x += colWidths[i];
            });
            y -= rowHeight;
        }
    });

    // Dibujar borde inferior (opcional, para cerrar tabla)
    page.drawLine({
        start: { x: margin, y },
        end: { x: width - margin, y },
        thickness: 1,
        color: rgb(0, 0, 0),
    });

    // Descargar PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
}
